/* global jQuery */
import jQuery from 'jquery';
import Svg4Everybody from 'svg4everybody';
// import Ps from 'perfect-scrollbar';
// import Select2 from 'select2';
import objectFitImages from 'object-fit-images';

// Relative Imports
import AnimateNumbers from "./modules/animated-numbers";
import Cookies from './modules/cookies';
import Header from './modules/header';
import Filters from './modules/filters';
import Footnotes from './modules/footnotes';
import SocialSharing from './modules/social-sharing';
import AccessibleMenu from './modules/accessible-menu';

(function ($) {
    const debug = true;
    const mobileBreakpoint = 747;

    new Header(mobileBreakpoint);

    /**
     * Civic Cookies
     */
    new Cookies();

    /**
     * Footnotes
     */
    new Footnotes();

    /**
     * Filters
     */
    new Filters('.js-filters');

    /**
     * Social sharing
     */
    new SocialSharing('.js-social-share');

    /**
     * Animate Numbers
     */
    new AnimateNumbers();

    /**
     * Accessible Menu
     */
    new AccessibleMenu();

    /**
     * SVG4Everybody
     */
    new Svg4Everybody();

    /**
     * Object fit polyfill
     */
    objectFitImages();

    // Select2 Example
    // new Select2();
    //
    // $('.js-sorter').select2({
    //     minimumResultsForSearch: -1,
    //     width: '100%'
    // });

    // Perfect Scrollbar Example
    // addScrollbars () {
    //     for (let i = 0; i < this.$filterLists.length; i++) {
    //         this.scrollbars.push(new Ps(this.$filterLists[i]));
    //     }
    // }
    //
    // updateScrollbars () {
    //     this.scrollbars.forEach((ps) => ps.update());
    // }

}(jQuery));
